import { Module } from '@nestjs/common';
import { ComprasModule } from 'src/compras/compras.module';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { ImportacionesController } from './importaciones.controller';
import { ImportacionesBitacoraPresenter } from './services/importaciones-bitacora.presenter';
import { ImportacionesCosteoService } from './services/importaciones-costeo.service';
import { ImportacionesCxPService } from './services/importaciones-cxp.service';
import { ImportacionesIscService } from './services/importaciones-isc.service';
import { ImportacionesService } from './services/importaciones.service';

@Module({
  imports: [ContabilidadModule, ComprasModule],
  controllers: [ImportacionesController],
  providers: [
    ImportacionesService,
    ImportacionesBitacoraPresenter,
    ImportacionesCosteoService,
    ImportacionesIscService,
    ImportacionesCxPService,
  ],
  exports: [ImportacionesService, ImportacionesCosteoService],
})
export class ImportacionesModule {}
